import { render, staticRenderFns } from "./SacleBox.vue?vue&type=template&id=929f896a&"
import script from "./SacleBox.vue?vue&type=script&lang=js&"
export * from "./SacleBox.vue?vue&type=script&lang=js&"
import style0 from "./SacleBox.vue?vue&type=style&index=0&id=929f896a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports